import { IdentifierDTO } from '@zazume/zzm-base';

import { UserConsentsByBackgroundCheck } from '#/models/UserConsent';

import { doGet, doPost } from '../../helpers';

export const userConsents = {
  getByBackgroundCheck: (backgroundCheckId: IdentifierDTO) => () =>
    doGet<UserConsentsByBackgroundCheck>(`/user-consents/by-background-check/${backgroundCheckId}`),
  relaunchForParticipant: (backgroundCheckId: IdentifierDTO) => (participantId: IdentifierDTO) =>
    doPost<void>(`/user-consents/by-background-check/${backgroundCheckId}/participants/${participantId}/relaunch`)
};
